import { render } from "./fps.vue?vue&type=template&id=5db76a0a&scoped=true"
import script from "./fps.vue?vue&type=script&lang=js"
export * from "./fps.vue?vue&type=script&lang=js"

import "./fps.vue?vue&type=style&index=0&id=5db76a0a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db76a0a"]])

export default __exports__